import React from "react";
import { useParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

const BusinessUnitSettingsPage = () => {
  const { businessUnitId } = useParams();

  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Business Unit Settings</h1>
        <p className="text-muted-foreground">
          Configure settings and preferences for this business unit
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Business Unit Configuration</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8 text-muted-foreground">
            Business unit settings interface will be implemented here.
            <br />
            Business Unit ID: {businessUnitId}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BusinessUnitSettingsPage;
